var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star",
    "data-name": "Icon awesome-star",
    d: "M8.137.521,6.306,4.4l-4.1.624a.949.949,0,0,0-.5,1.6L4.677,9.64l-.7,4.262a.905.905,0,0,0,1.3.987l3.664-2.012,3.664,2.012a.906.906,0,0,0,1.3-.987l-.7-4.262,2.964-3.017a.949.949,0,0,0-.5-1.6l-4.1-.624L9.746.521A.881.881,0,0,0,8.137.521Z",
    transform: "translate(-1.441 0.001)",
    fill: "#fccd4f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.a2bc0b7055894fda2d4045fe2fa93af3.svg";
export { ForwardRef as ReactComponent };